import axios from "axios";
import config from "../@config";
import cookie from "./cookie";
import store from "../@store";
import { message } from "antd";
const RESPONSE_SUCCESS_CODE = [200];
const _axios = axios.create({
  baseURL: config.BASE_API,
  timeout: 10000,
});
export const getRequestHeader = () => {
  let authorization = cookie.get("authorization");
  if (authorization) authorization = "Bearer " + authorization;
  return {
    authorization,
  };
};
_axios.interceptors.request.use(
  function (config) {
    let { headers, ...restConfigs } = config;
    return {
      ...restConfigs,
      headers: {
        ...headers,
        ...getRequestHeader(),
      },
    };
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
_axios.interceptors.response.use(
  function (response) {
    const responeseBody = response.data;
    return responeseBody;
  },
  function (error) {
    const res = error.response;
    return {
      code: res.status,
      message: res.statusText,
    };
  }
);
_axios.interceptors.response.use(function (response) {
  return response;
});
const request = {
  get: (url, options = {}) => {
    const { headers = {}, ...restOptions } = options;
    return _axios.get(url, {
      ...restOptions,
      headers: {
        ...headers,
      },
    });
  },
  post: (url, options = {}) => {
    const { headers = {}, data, ...restOptions } = options;
    return _axios.post(url, data, {
      ...restOptions,
      headers: {
        ...headers,
      },
    });
  },
  delete: (url, options = {}) => {
    const { headers = {}, data, ...restOptions } = options;
    return _axios.delete(url, data, {
      ...restOptions,
      headers: {
        ...headers,
      },
    });
  },
};
export default request;

